import { render, staticRenderFns } from "./EpiteliumQuiz.vue?vue&type=template&id=144a91c0&scoped=true"
import script from "./EpiteliumQuiz.vue?vue&type=script&lang=js"
export * from "./EpiteliumQuiz.vue?vue&type=script&lang=js"
import style0 from "./EpiteliumQuiz.vue?vue&type=style&index=0&id=144a91c0&prod&lang=scss&scoped=true"
import style1 from "./EpiteliumQuiz.vue?vue&type=style&index=1&id=144a91c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a91c0",
  null
  
)

export default component.exports